import { apiRequest } from './apiClient';

export async function getStudentChallenges() {
  const response = await apiRequest('/student/challenges');

  return response.data || [];
}

export async function getStudentChallengeById(challengeId) {
  const response = await apiRequest(`/student/challenges/${challengeId}`);

  return response.data || null;
}

export async function submitStudentChallenge(challengeId, answers) {
  const response = await apiRequest(`/student/challenges/${challengeId}/submit`, {
    method: 'POST',
    body: { answers },
  });

  return response.data || null;
}
